import { useState } from 'react';
import { Users, Briefcase, BookOpen, X, Check, Layers} from 'lucide-react';
import AddPublication from './AddPublication';
import AddJD from './AddJD';
import ViewCandidate from './ViewCandidate';

export default function Dashboard() {
  const [activeTab, setActiveTab] = useState('candidates');
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');

  const tabs = [
    { key: 'candidates', label: 'View Candidates', icon: Users },
    { key: 'add-jd', label: 'Add Job Description', icon: Briefcase },
    // { key: 'add-publication', label: 'Add Publication', icon: BookOpen },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'candidates':
        return <ViewCandidate />;
      case 'add-jd':
        return <AddJD />;
      case 'add-publication':
        return <AddPublication />;
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-indigo-100 via-blue-200 to-purple-300">
      {/* Notification */}
      {showNotification && (
        <div className="fixed top-4 right-4 z-50 bg-white shadow-lg rounded-lg p-4 flex items-center border-l-4 border-green-500 animate-pulse">
          <div className="p-1 bg-green-100 rounded-full mr-3">
            <Check className="h-4 w-4 text-green-500" />
          </div>
          <span className="font-medium">{notificationMessage}</span>
          <button
            onClick={() => setShowNotification(false)}
            className="ml-4 text-gray-400 hover:text-gray-500 transition-colors"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      )}

      {/* Header */}
      <header className="bg-white border-b border-gray-300 shadow-lg px-6">
        <div className="m py-4">
          <div className="flex justify-between items-center">
            {/* Logo */}
            <div className="flex items-center space-x-3">
              <div className="bg-gradient-to-r from-indigo-600 via-blue-500 to-purple-600 rounded-lg p-2 shadow-lg transform hover:scale-105 transition-transform duration-300">
                <Layers className="h-6 w-6 text-white" />
              </div>
              <h1 className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-indigo-800 via-blue-700 to-purple-800">
                Dashboard
              </h1>
            </div>

            {/* User Actions */}
            <div className="flex items-center space-x-5">
              {/* <button className="p-2 rounded-full hover:bg-indigo-100 transition-colors relative group">
                <Bell className="h-5 w-5 text-indigo-600 group-hover:text-indigo-800 transition-colors" />
                <span className="absolute top-0 right-0 h-2 w-2 bg-red-500 rounded-full group-hover:animate-ping"></span>
              </button> */}
              <div
                className="h-10 w-20 rounded-full bg-gradient-to-r from-indigo-500 via-blue-500 to-purple-500 flex items-center justify-center text-white font-medium shadow-lg hover:shadow-xl transition-shadow cursor-pointer overflow-hidden relative hover:scale-105 transition-transform duration-300"
                onClick={() => {
                  sessionStorage.removeItem("isAuthenticated");
                  window.location.href = "/admin";
                }}
              >
                <div className="absolute inset-0 bg-white opacity-0 hover:opacity-10 transition-opacity"></div>
                <span>Sign Out</span>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-grow">
        <div className=" py-8 px-6">
          {/* Dashboard Title */}
          {/* <div className="mb-8">
            <div className="flex items-center">
              <div className="mr-4">
                <div className="h-12 w-1 bg-gradient-to-b from-indigo-600 via-blue-600 to-purple-600 rounded-full shadow-md"></div>
              </div>
              <div>
                <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">Dashboard</h2>
                <p className="mt-1 text-sm text-gray-600">Streamlined talent management system</p>
              </div>
            </div>
          </div> */}

          {/* Tabs */}
          <div className="border-b border-gray-300 mb-8 bg-white rounded-t-xl shadow-md overflow-hidden">
            <nav className="px-6 flex space-x-3 overflow-x-auto py-3">
              {tabs.map(({ key, label, icon: Icon }) => (
                <button
                  key={key}
                  onClick={() => setActiveTab(key)}
                  className={`flex items-center whitespace-nowrap py-3 px-5 font-medium text-sm transition-all rounded-lg ${
                    activeTab === key
                      ? 'bg-gradient-to-r from-indigo-600 via-blue-500 to-indigo-500 text-white shadow-md transform scale-105'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-indigo-700'
                  }`}
                >
                  <Icon className={`h-4 w-4 mr-2 ${activeTab === key ? 'animate-pulse' : ''}`} />
                  {label}
                </button>
              ))}
            </nav>
          </div>

          {/* Tab Content */}
          <div className="bg-white shadow-xl rounded-xl border border-gray-100 overflow-hidden transition-all duration-300 hover:shadow-2xl">
            <div className="p-4">
              <div className="bg-gradient-to-r from-indigo-50 via-blue-50 to-purple-50 p-6 rounded-lg">
                {renderTabContent()}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}